import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'

import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '「佐渡島（さど）の金山」をフカボリ！―世界遺産登録への道― | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="みんなで学ぶ連載記事" />
      <SectionTitle sectionTitle="「佐渡島（さど）の金山」をフカボリ！―世界遺産登録への道―⑥" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023秋号 No.164 目次",
                path: "/no164"
              },
              {
                name: "みんなで学ぶ連載記事"
              }
            ]}
          />
        <p>この連載では、「佐渡島（さど）の金山」の見どころや歴史などを毎回お伝えします。県民みんなで知識の鉱脈をフカボリしましょう！<br />県では世界遺産登録に向け、今後も取り組んでいきます。</p>
        
        <div>
          <img
            src={`${basePath}/no164/img/4-1.png`}
            alt="佐渡を世界遺産に"
            css={style.img(200, "15px 0 0 0")}
          />
        </div>
        
        <p>鶴子（つるし）銀山は16世紀中頃に発見された佐渡最古の銀山です。<br />採掘の初期は地表近くの鉱石を掘り取る「露頭掘り（ろとうぼり）」、「ひ追い掘り（ひおいぼり）」でしたが、16世紀末頃、石見（いわみ）銀山から来た山師によって「坑道掘り（こうどうぼり）」が伝えられ、地中の鉱石を効率的に掘ることができるようになり、銀の産出量が飛躍的に増加しました。このような歴史から鶴子銀山では様々な採掘方法を、600を超える採掘跡から見ることができます。<br />鶴子銀山の繁栄により、佐渡島に山師や商人など様々な人が集まり、開発が進められたことで国内最大の相川金銀山が発見され、佐渡島の金山はさらなる発展を遂げていくこととなります。</p>

        
        <div>
          <img
            src={`${basePath}/no164/img/4-2.png`}
            alt="大滝間歩（おおたきまぶ）　鶴子銀山を代表する坑道の一つ（撮影：西山芳一氏）"
            css={style.img(600, "15px 0 15px 0")}
          />
        </div>
        
        <p>詳しくは
          <a
            href="https://www.sado-goldmine.jp/"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        <br />
        <p>【問い合わせ】<br />文化課&emsp;世界遺産登録推進室&emsp;電話：<a href="tel:025-280-5726">025-280-5726</a></p>
        
        <BackBtn href={"/no164"} />
      </Content>
    </Page>
  )
}
export default Home
